( function () {
	'use strict';
	// Bypass for now needs to be refactored too big
	/* eslint-disable max-params */
	function CreateScheduleModalCtrl ( $scope, $filter, $route, logger, $modalInstance, createschedservice, scheduleservice, dateModel, SCHEDULE_MESSAGES, createObsService, $q, persistence, $timeout ) {
		/* eslint-enable max-params */
		var self = this;

		self.navs          = [ 'Observation', 'Meeting' ];
		self.activeNav     = persistence.scheduleActiveList;
		self.message       = SCHEDULE_MESSAGES;
		self.fetchTimeout  = false;
		self.isEventHidden = false;

		function openCalendarPicker ( dateType ) {
			if ( dateType === 'start' ) {
				self.isOpenCalendar = !self.isOpenCalendar;
			} else {
				self.isOpenCalendarEnd = !self.isOpenCalendarEnd;
			}
		}

		function disableDatesHandler ( date, mode ) {
			return createschedservice.disableDates( date, mode );
		}

		function tabber ( next, e, isFromDescription ) {
			if ( !isFromDescription && self.activeNav && next === 'locationss' ) {
				next = 'descriptions';
			}

			if ( e.which === 9 ) {
				if ( next === 'inviteess' && self.disableObservees ) {
					next = 'templatess';
				}

				if ( !$scope.$$phase ) {
					angular.element( '#' + next ).click();
				} else {
					$timeout( function () {
						angular.element( '#' + next ).click();
					}, 0 );
				}
			}
		}

		function incorrectTimeHandler () {
			var pastTime      = createschedservice.incorrectTime( self.schedule.eventDate, self.schedule.startTime );
			var incorrectTime = createschedservice.incorrectTime( self.schedule.eventDate, self.schedule.startTime, self.schedule.endTime );

			return pastTime || incorrectTime || createschedservice.incorrectEndTime( self.schedule );
		}

		function saveScheduleHandler ( form ) {
			if ( form.$valid && !incorrectTimeHandler() ) {
				self.displayMsgToUser = true;

				if ( self.activeNav ) {
					self.schedule.templateId = null;
				}

				self.schedule.type          = self.navs[ self.activeNav ];
				self.schedule.isEventHidden = self.isEventHidden;

				scheduleservice.saveSchedule( self.schedule ).then( function () {
					self.scheduleSuccess = true;

					logger.notifySuccess( 'Successfully saved.', 'Event' );

					$modalInstance.close();
					$route.reload();
				}, function () {
					logger.notifyError( 'An error occurred. Please try again.', 'Event' );

					self.scheduleSuccess = false;
				} ).finally( function () {
					$modalInstance.close();
				} );
			}
		}

		function cancelModal () {
			$modalInstance.dismiss( 'cancel' );
		}

		function getSelectedByPointer ( selections, pointer ) {
			return $filter( 'filter' )( selections, function ( selection ) {
				return selection.pointer === pointer;
			} );
		}

		function getObserveesAndLocationId ( selections ) {
			var school = getSelectedByPointer( selections, 'SchoolName' );

			if ( school.length && self.schedule.locationId !== school[ 0 ].data.ID ) {
				self.schedule.invitees = [ ];
			}

			if ( school.length ) {
				self.schedule.observeeId = '';
				self.observees           = school[ 0 ].data.users;
				self.schedule.locationId = school[ 0 ].data.ID;
				self.disableObservees    = false;
			}
		}

		function removeObserveeSelection () {
			var observeeSelection = self.selections.filter( function ( selection ) {
				return selection.pointer === 'FirstName';
			} );

			if ( observeeSelection.length ) {
				self.selections.splice( self.selections.indexOf( observeeSelection[ 0 ] ), 1 );
			}
		}

		function removeObservee ( data ) {
			self.schedule.invitees.splice( self.schedule.invitees.indexOf( data ), 1 );

			$scope.$broadcast( 'removeObservee', data );
		}

		function inInvitees ( id ) {
			return self.schedule.invitees.some( function ( invitee ) {
				return invitee.id === id;
			} );
		}

		function getObservee ( selections ) {
			var observee = getSelectedByPointer( selections, 'FirstName' );

			if ( observee.length && !self.activeNav ) {
				self.schedule.observeeEmail     = observee[ 0 ].data.EmailAddress;
				self.schedule.observeeFirstName = observee[ 0 ].data.FirstName;
				self.schedule.observeeLastName  = observee[ 0 ].data.LastName;
				self.schedule.observeeClientId  = observee[ 0 ].data.ClientId;
				self.schedule.observeeId        = observee[ 0 ].data.PersonnelId;
			}

			if ( observee.length && self.activeNav && !inInvitees( observee[ 0 ].data.PersonnelId ) ) {
				self.teacher = 'Select a Teacher';
				self.schedule.invitees.push( {
					'id'   : observee[ 0 ].data.PersonnelId,
					'name' : observee[ 0 ].data.FirstName + ' ' + observee[ 0 ].data.LastName
				} );

				removeObserveeSelection();
			}
		}

		function getTemplate ( selections ) {
			var template = getSelectedByPointer( selections, 'name' );

			if ( template.length ) {
				self.schedule.template     = template[ 0 ].data;
				self.schedule.templateId   = template[ 0 ].data.id;
				self.schedule.templateName = template[ 0 ].data.name;
			} else {
				self.schedule.template     = '';
				self.schedule.templateId   = '';
				self.schedule.templateName = '';
			}
		}

		function removeTemplate () {
			self.schedule.templateId = '';
			self.templateMarker      = 'Select a Template';
			self.templateRemoved     = true;

			var selectedTemplate = self.selections.filter( function ( selection ) {
				return selection.pointer === 'name';
			} );

			var index = self.selections.indexOf( selectedTemplate[0] );

			self.selections.splice( index, 1 );
		}

		function getData () {
			self.fetchTimeout = true;
			createObsService.getPreLoadedData().then( function ( q ) {
				$q.all( [ q[ 0 ].$promise, q[ 1 ].$promise ] )
				.then( function ( res ) {
					if ( res.length ) {
						self.templates = createObsService.getReorderedTemplates( res[ 0 ], res[ 1 ] );
						return self.templates;
					}
					self.fetchTimeout = false;
					return self.fetchTimeout;
				}, function () {
					self.fetchTimeout = false;
					return self.fetchTimeout;
				} );

				q[ 2 ].$promise.then( function ( districts ) {
					var schools = [];

					// look into all districts
					( districts || [] ).map( function ( district ) {
						schools = schools.concat( district.Schools || [] );
					} );

					if ( schools.length ) {
						self.schools = schools;
						return self.schools;
					}
					self.fetchTimeout = false;
					return self.fetchTimeout;
				}, function () {
					self.fetchTimeout = false;
					return self.fetchTimeout;
				} );
			} );
		}

		function switchTabView () {
			self.teacher             = 'Select a Teacher';
			self.schedule.observeeId = '';
			self.schedule.invitees   = [ ];
			removeObserveeSelection();
		}

		function validateEventDate ( $event ) {
			var dateRegex = /^(0[0-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/([0-9]\d{1})$/;

			self.invalidDateFormat = !dateRegex.test( $event.currentTarget.value );
			self.invalidDate       = createschedservice.invalidDate( $event.currentTarget.value );
		}

		function activate () {
			logger.info( 'Activated Create Schedule Modal View' );

			getData();

			$scope.$watch( function () {
				return self.selections;
			}, function ( newVal ) {
				if ( newVal ) {
					getObserveesAndLocationId( newVal );
					getObservee( newVal );
					getTemplate( newVal );
				}
			}, true );

			$scope.$watch( 'vm.schedule.locationId', function ( newVal, oldVal ) {
				if ( newVal !== oldVal ) {
					self.schedule.observeeId = '';
				}
			} );

			$scope.$watch( 'vm.schedule.templateName', function ( newVal ) {
				if ( newVal ) {
					self.templateMarker = self.schedule.templateName;
				}
			} );

			$scope.$watch( 'vm.inviteeMarker', function () {
				self.inviteeMarker = 'Select a Person(s)';
			} );
		}

		activate();

		// defaults
		self.selections       = [ ];
		self.disableObservees = true;
		self.teacher          = 'Select a Teacher';
		self.templateMarker   = 'Select a Template';
		self.templateRemoved  = false;
		self.notifyUser       = false;

		// create schedule collections
		self.templates  = [ ];
		self.observees  = [ ];
		self.schools    = [ ];

		// create schedule data
		self.schedule     = {
			'locationId' : '',
			'eventDate'  : createschedservice.formatDefaultDate( dateModel ) || createschedservice.getCurrentDate(),
			'startTime'  : createschedservice.getCurrentDate(),
			'endTime'    : createschedservice.getCurrentDate( 1 ),
			'name'       : '',
			'observerId' : createschedservice.getUserId(),
			'observeeId' : '',
			'invitees'   : [ ],
			'templateId' : '',
			'creatorId'  : createschedservice.getUserId()
		};

		// calendar picker options
		self.isOpenCalendar    = false;
		self.isOpenCalendarEnd = false;

		self.schedule.endDate = angular.copy( self.schedule.eventDate );

		self.dateOptions    = {
			'formatYear'  : 'yyyy',
			'startingDay' : 0
		};

		// handlers
		self.removeTemplate       = removeTemplate;
		self.openCalendarPicker   = openCalendarPicker;
		self.disableDatesHandler  = disableDatesHandler;
		self.incorrectTimeHandler = incorrectTimeHandler;
		self.saveScheduleHandler  = saveScheduleHandler;
		self.cancelModal          = cancelModal;
		self.switchTabView        = switchTabView;
		self.validateEventDate    = validateEventDate;
		self.removeObservee       = removeObservee;
		self.tabber               = tabber;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'CreateScheduleModalCtrl', CreateScheduleModalCtrl );

	CreateScheduleModalCtrl.$inject = [
		'$scope',
		'$filter',
		'$route',
		'logger',
		'$modalInstance',
		'createschedservice',
		'scheduleservice',
		'dateModel',
		'SCHEDULE_MESSAGES',
		'createObsService',
		'$q',
		'persistence',
		'$timeout'
	];
} )( );
